import { type ProgressStylesType } from '@material-tailwind/react';

const styles: ProgressStylesType = {
  defaultProps: {
    variant: 'gradient',
    color: 'blue',
    size: 'lg',
  },
  styles: {
    base: {
      container: {
        initial: {
          bg: 'bg-white',
          rounded: 'rounded-xl',
          border: 'border border-gray-300',
          spacings: 'p-1',
        },
      },
      bar: {
        text: 'text-white text-xs font-normal float-right px-1',
        width: 'min-w-4',
        justifyContent: 'justify-end',
      },
    },
    sizes: {
      lg: {
        container: {
          initial: {
            height: 'h-6.5',
          },
          withLabel: {
            height: 'h-6.5',
          },
        },
      },
    },
    variants: {
      gradient: {
        blue: {
          background: 'bg-gradient-to-r from-white to-blue-500',
        },
        green: {
          background: 'bg-gradient-to-r from-white to-green-500',
        },
      },
    },
  },
  valid: {
    variants: ['gradient'],
    sizes: ['lg'],
    colors: ['blue', 'green'],
  },
};

export default styles;
